import { decodeJwtPayload } from "@core/foundation/jwt";

import { UserClaimsSchema } from "../../models/index.ts";

export function isAdminToken(token: string): boolean {
  const payload = decodeJwtPayload(token);
  const userClaims = UserClaimsSchema.safeParse(payload);

  return userClaims.success && userClaims.data.role === "admin";
}

export function isUserToken(token: string): boolean {
  const payload = decodeJwtPayload(token);
  const userClaims = UserClaimsSchema.safeParse(payload);

  return userClaims.success;
}
